export const CONTACT_EMAIL = "grow@trees.cy";
